export default {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: 'flex-start',
    },
    strong: {
        display: "block",
        marginBottom: "10px",
        fontSize: "18px",
    },
    ul: {
        listStyleType: "none",
        padding: "0",
    },
    li: {
        marginBottom: "10px",
        display: "flex",
        alignItems: "center",
    },
    bullet: {
        marginRight: "10px",
        fontSize: "20px",
    },
    instructionCard: {
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "20px",
        backgroundColor: "#f9f9f9",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        width: "70%",
    },
    containerdropdown: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '20px',
    },
    label: {
        marginRight: '30px',
        fontWeight: 'bold',
    },
    select: {
        padding: '5px',
        borderRadius: '10px',
        border: '1px solid #ccc',
    },
    marginBottomStyle: {
        marginBottom: '25px',
    },
    dropdownWidth: {
        width: '120px',
    },
    gridButtonGap: {
        marginLeft: '50px',
        marginRight: '-50px',
    },
    gridRecordsMargin: {
        marginLeft: '150px',
    },
    gridcheckboxRecordsMargin: {
        marginLeft: '50px',
    },
    popupContainer: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        border: '1px solid #ccc',
        borderRadius: '5px',
        padding: '20px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        maxWidth: '80%',
    },
    popupTitle: {
        fontSize: '20px',
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    popupContent: {
        marginBottom: '20px',
    },
    popupParagraph: {
        marginBottom: '10px',
    },
}